export const TIMEOUTS = {
  DEFAULT: 1800000, // 30 mins
  MINUTE_IN_MILISECONDS: 60000,
  HOUR_IN_MILISECONDS: 3600000,
  HOUR_IN_MINUTES: 60
};
